module.exports = __webpack_public_path__ + "static/media/services-icon2.90b39e7f.png";